<template>
  <div class="DataTables PartDetailsComponent ">



    <p v-if="!isRevision">{{lang.infotext_1}}</p>
    <LoaderComponent v-if="!isData"></LoaderComponent>
    <span v-if="selectedRevisionRow.length > 0">
      

      <div :id="id"></div>
      <p v-show="isEdit">
        <b-badge class="badge badge-blue">Request</b-badge> - {{lang.infotext_Request}}
      </p>
      <p v-show="isEdit">
        <b-badge class="badge badge-yellow">Release</b-badge> - {{lang.infotext_Release}}
      </p>
      <p v-show="isEdit">
        <b-badge class="badge badge-danger">Revision</b-badge> - {{lang.infotext_Revision}}
      </p>
    </span>
  </div>
</template>
<script>
  import LibraryTypes from '@/constants/LibraryTypes'
  import LibraryPropertiesType from '@/constants/LibraryPropertiesType'
  import PartPropertiesType from '@/constants/PartPropertiesType'
  import LoaderComponent from "@/components/shared/LoaderComponent"
  import { mapGetters } from 'vuex'

  export default {
    name: "PartDetailsComponent",
    props:{
      lang: Object
    },
    components: {

      LoaderComponent
    },
    data () {
      return {

        mainTable: "",
        id: "PartDetailsTable",
        properties: [],
        pureProperties: [],
        propertiesRevNumbers: [],
        colorValues: [],
        currentPackage: {},
        currentHDLPackage: {},
        packages: {},
        packagesHDL: {},
        symbolSvg: {},
        place: {},
        placeHDL: {},
        currentRevisionId: "",
        currentSymbolObject: {
          name: "",
          partRevisionId: "",
          type: ""
        },
        currentHDLSymbolObject: {
          name: "",
          partRevisionId: "",
          type: ""
        },
        altSymbolsParams: {}
      }
    },
    computed: {
      ...mapGetters({

        globalSettings: "globalSettings"

      }),
      isEdit(){
        return this.$store.getters.isEditPropertyForm;
      },
      selectedRevisionRow(){
        return this.$store.getters.selectedRevisionRow;
      },
      isData(){
        return this.properties.length == this.$store.getters.selectedRevisionRow.length;
      },
      isRevision(){

        return this.$store.getters.selectedRevisionRow.length != 0;

      },
      
      lastRevisionHistory(){
  
        let tab = this.$store.getters.revisionHistory;
        let obj = tab[0];
        for (let i = 0, lei = tab.length; i < lei; i++){
          
          if (tab[i].revision > obj.revision){
            obj = tab[i];
          }
        }
        
        return obj;
      },
      selectedLastRevisionRow(){
        if (this.$store.getters.selectedRevisionRow.length == 0){
          return false;
        }
        return this.$store.getters.selectedRevisionRow[0].revisionId == this.lastRevisionHistory.id;
      },
      variant(){
        if (this.$store.getters.s_skinVariant == "dark"){
          return "light";
        }else{
          return "dark";
        }
        
      },
      focusedField() {
        return 
      },
      propertyToSaving() {
        return this.$store.getters.propertyToSaving;
      },
      
    },
    created () {
      

      this.loadDataForRevisions();
      this.getAltSymbolsParams();
      this.$store.dispatch("setSaveStatus", false);

    },
    watch: {
      
      isEdit: function(){
        

        this.loadDataForRevisions();
      },
      properties: function(){
        
        if (this.isData){

          if (this.properties.length != 0){
            for (let i = 0; i < this.propertiesRevNumbers.length; i++) {
              for (let j = 0; j < this.propertiesRevNumbers.length - i - 1; j++) {
                if (this.propertiesRevNumbers[j] < this.propertiesRevNumbers[j + 1]) {
                  const temp = this.propertiesRevNumbers[j + 1];
                  const temp2 = this.properties[j + 1];
                  this.propertiesRevNumbers[j + 1] = this.propertiesRevNumbers[j];
                  this.properties[j + 1] = this.properties[j];
                  this.propertiesRevNumbers[j] = temp;
                  this.properties[j] = temp2;

                }
              }
            }



            let partsData = [];

            for(let i = 0, lei = this.properties[0].length; i < lei; i++){
              let objRow = {
                id:  this.properties[0][i].id,
                name: this.properties[0][i].name,
                priority: this.properties[0][i].priority,
                type: this.properties[0][i].type,
                isRequiredOnRequest: this.properties[0][i].isRequiredOnRequest,
                isRequiredOnRelease: this.properties[0][i].isRequiredOnRelease,
                isRevisionChanging: this.properties[0][i].isRevisionChanging,
                hdlDesignation: this.properties[0][i].hdlDesignation,
                cisDesignation: this.properties[0][i].cisDesignation
              }

              for(let j = 0, lej = this.properties.length; j < lej; j++){


                let revValue = [];
                let isTheSame = [];
                for(let k = 0, lek = this.properties[j].length; k < lek; k++){

                  if (this.properties[j][k].value == null){

                    this.properties[j][k].value = {display: "", filter: "", sort: ""}

                  }


                  if(this.properties[0][k].value.display == this.properties[j][k].value.display){
                    this.properties[j][k].isTheSameLikeLastRev = true;
                  }else{
                    this.properties[j][k].isTheSameLikeLastRev = false;
                  }

                  revValue.push(this.properties[j][k].value);
                  isTheSame.push(this.properties[j][k].isTheSameLikeLastRev);
                }


                let key = "value___" + this.propertiesRevNumbers[j];

                objRow[key] = revValue[i];
                objRow.value = revValue[i].display;
                objRow.isTheSameLikeLastRev = isTheSame[i];
              }

              partsData.push(objRow);
            }


          this.buildTable(partsData)
          }


        }

      },
      selectedRevisionRow: function () {
        
        this.loadDataForRevisions();

      },
      currentSymbolObject: {
        handler: function(newVal){
          
          let vue = this;
          if (newVal.name != "") {
            let idL = "detailslibsymbolprop__" + newVal.partRevisionId;
            let partRevisionId = newVal.partRevisionId;

            const objL = {
              type: LibraryTypes.PART,
              name: newVal.name,
              idL: idL
            }

            this.$store.dispatch("lm_getIdOfActiveLibrary", objL)
            .then((result) => {
              console.log(result)
              if (result.data != null) {



                vue.loadLibraryProps(result.data, LibraryTypes.PART, partRevisionId);


              } else {
                vue.cleanLibraryProps(idL);
              }

            })
          }
          
        },
        deep: true
      
        
      },
      currentHDLSymbolObject: {
        handler: function (newVal) {

          if (newVal.name != "") {

            let vue = this;

            let idL = "detailslibsymbolprop__" + newVal.partRevisionId;
            let partRevisionId = newVal.partRevisionId;

            const objL = {
              type: LibraryTypes.HDLSYMBOL,
              name: newVal.name,
              idL: idL
            }

            this.$store.dispatch("lm_getIdOfActiveLibrary", objL)
              .then((result) => {
                console.log(result)
                if (result.data != null) {



                  vue.loadLibraryProps(result.data, LibraryTypes.HDLSYMBOL, partRevisionId);


                } else {
                  vue.cleanLibraryProps(idL);
                }

              })
          }
        },
        deep: true


      },
    },
        
  methods: {
      getAltSymbolsParams() {

        let vue = this;

        this.$store.dispatch(this.$store.getters.sectionPrefix + "_getAltSymbolsParams")
          .then((result) => {
            console.log(result)
            vue.altSymbolsParams = result.data[0];

          })

      },
      checkIfSaved() {

        let trig = false;
        for (let i = 0, lei = this.properties[0].length; i < lei; i++) {
          
          if (this.pureProperties[i].value.display != this.propertyToSaving[i].value) {
          
            trig = true;
          } 
        }
        
        if (trig == true) {
          this.$store.dispatch("setSaveStatus", true)
        } else {
          this.$store.dispatch("setSaveStatus", false)
        }
      },
      setPackage(revisionId){
        
        let barValue = document.getElementById("barDetailValue_" + revisionId + "_" + this.id);
        if (barValue != null){
          let index = this.currentPackage[revisionId] + 1;
          barValue.value = this.packages[revisionId][this.currentPackage[revisionId]] + " (" + index + "/" + this.packages[revisionId].length +")";

          let leftbar = document.getElementById("leftbarDetail_" + revisionId + "_" + this.id);
          let rightbar = document.getElementById("rightbarDetail_" + revisionId + "_" + this.id);

          if (this.currentPackage[revisionId] == 0){
            leftbar.disabled = true;
          }else{
            leftbar.disabled = false;
          }
          
          if (this.currentPackage[revisionId] == this.packages[revisionId].length - 1){
            rightbar.disabled = true;
          }else{
            rightbar.disabled = false;
          }

                      
          
          for (var i = 0, le = this.packages[revisionId].length; i < le; i++) {
              var layer = "PACKAGES_"+this.packages[revisionId][i];

              if (i == this.currentPackage[revisionId]) {
                  if (this.place[revisionId].getElementsByClassName(layer)[0] != undefined) {
                      this.place[revisionId].getElementsByClassName(layer)[0].style["visibility"] = "visible";
                  }
                  

              } else {
                  if (this.place[revisionId].getElementsByClassName(layer)[0] != undefined) {
                      this.place[revisionId].getElementsByClassName(layer)[0].style["visibility"] = "hidden";
                  }
              }


          }
        }
      },
      setHDLPackage(revisionId) {
        
        let barValue = document.getElementById("barHDLDetailValue_" + revisionId + "_" + this.id);
        if (barValue != null) {
          let index = this.currentHDLPackage[revisionId] + 1;
          barValue.value = this.packagesHDL[revisionId][this.currentHDLPackage[revisionId]] + " (" + index + "/" + this.packagesHDL[revisionId].length + ")";

          let leftbar = document.getElementById("leftbarHDLDetail_" + revisionId + "_" + this.id);
          let rightbar = document.getElementById("rightbarHDLDetail_" + revisionId + "_" + this.id);

          if (this.currentHDLPackage[revisionId] == 0) {
            leftbar.disabled = true;
          } else {
            leftbar.disabled = false;
          }

          if (this.currentHDLPackage[revisionId] == this.packagesHDL[revisionId].length - 1) {
            rightbar.disabled = true;
          } else {
            rightbar.disabled = false;
          }



          for (var i = 0, le = this.packagesHDL[revisionId].length; i < le; i++) {
            var layer = "PACKAGES_" + this.packagesHDL[revisionId][i];

            if (i == this.currentHDLPackage[revisionId]) {
              if (this.placeHDL[revisionId].getElementsByClassName(layer)[0] != undefined) {
                this.placeHDL[revisionId].getElementsByClassName(layer)[0].style["visibility"] = "visible";
              }


            } else {
              if (this.placeHDL[revisionId].getElementsByClassName(layer)[0] != undefined) {
                this.placeHDL[revisionId].getElementsByClassName(layer)[0].style["visibility"] = "hidden";
              }
            }


          }
        }
      },
      buildSymbolViewer(doc, place, revisionId){

        let vue = this;
        
        let svg  = doc.firstChild

        this.place[revisionId] = place;

        
        let symbolbar = document.getElementById("bar_" + this.place[revisionId].id + "_" + this.id);
        symbolbar.innerHTML = "";
        
        let group = this.place[revisionId].getElementsByTagName(`g`);
        
        this.packages[revisionId] = [];
        this.currentPackage[revisionId] = 0;
        for (let i = 0, lei = group.length; i < lei; i++){
          
          let temp = group[i].className.baseVal.split("_");
          if (temp[0] == "PACKAGES"){
            
            this.packages[revisionId].push(temp[1])
          }
        }


        if(this.packages[revisionId].length > 1){
          
          this.symbolSvg = svg;

          
          
          
          
          let index = this.currentPackage[revisionId] + 1;
          let valueBar = this.packages[revisionId][this.currentPackage[revisionId]] + " (" + index + "/" + this.packages[revisionId].length +")";

          const bar = `<div role="group" class="input-group  input-group-sm">
                      <div class="input-group-prepend">
                      <button disabled="disabled" id="leftbarDetail_`+revisionId+"_"+this.id+`" type="button" class="btn btn-sm btn-`+this.variant+` btn-bar">&lt;</button>
                      </div> 
                      <input type="text" class="form-control form-control-sm" disabled="disabled" id="barDetailValue_`+revisionId+"_"+this.id+`" value="`+ valueBar +`" style="text-align:center;"> 
                      <div class="input-group-append">
                      <button id="rightbarDetail_`+revisionId+"_"+this.id+`" type="button" class="btn btn-sm btn-`+this.variant+` btn-bar">&gt;</button>
                      </div>
                      </div>`;

          symbolbar.innerHTML = bar;

          let leftbar = document.getElementById("leftbarDetail_" + revisionId + "_" + this.id);
          leftbar.addEventListener("click", function(e) {

            vue.currentRevisionId = revisionId;
            
            if (vue.currentPackage[revisionId] == 0){
              
            }else{
              
              vue.currentPackage[revisionId]--;
              vue.setPackage(revisionId);
            }
            
          })
          
          let rightbar = document.getElementById("rightbarDetail_" + revisionId + "_" + this.id);
          rightbar.addEventListener("click", function(e) {
            
            vue.currentRevisionId = revisionId;

            if (vue.currentPackage[revisionId] == vue.packages[revisionId].length){
              
            }else{
              
              vue.currentPackage[revisionId]++;
              vue.setPackage(revisionId);
            }
          })

          


        }else{
            this.symbolSvg = {};
        }

        let symbol_select = document.getElementById("symbolDetail_select_" + revisionId + "_" + vue.id);
        symbol_select.addEventListener("change", function(e){
          
          let id = "symbolDetail__" + revisionId;

          let type = this.dataset.type
          
          const symbolObj = {
            name: this.value,
            partRevisionId: revisionId,
            //libraryType: LibraryTypes.PART,
            type: type
          }

          vue.currentSymbolObject = Object.assign({}, vue.currentSymbolObject, symbolObj);

          let place = document.getElementById("symbolDetail__" + revisionId);
          if (place != null) {
            place.setAttribute("data-name", this.value);
          }
          

          const obj = {
            type: LibraryTypes.PART,
            name: this.value,
            id: id
          }
          
          
          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
          .then((result) => {
            
            if (result != null){
              
              let id = result.id;
                                        
              vue.loadSVG(result, id, revisionId);
              
              
            }
          
          })
          

        })

              

      },
      buildHDLSymbolViewer(doc, place, revisionId) {

        let vue = this;

        let svg = doc.firstChild

        this.placeHDL[revisionId] = place;


        let symbolbar = document.getElementById("bar_" + this.placeHDL[revisionId].id + "_" + this.id);
        symbolbar.innerHTML = "";
        
        let group = this.placeHDL[revisionId].getElementsByTagName(`g`);

        this.packagesHDL[revisionId] = [];
        this.currentHDLPackage[revisionId] = 0;
        for (let i = 0, lei = group.length; i < lei; i++) {

          let temp = group[i].className.baseVal.split("_");
          if (temp[0] == "PACKAGES") {

            this.packagesHDL[revisionId].push(temp[1])
          }
        }


        if (this.packagesHDL[revisionId].length > 1) {

          this.symbolSvg = svg;





          let index = this.currentHDLPackage[revisionId] + 1;
          let valueBar = this.packagesHDL[revisionId][this.currentHDLPackage[revisionId]] + " (" + index + "/" + this.packagesHDL[revisionId].length + ")";

          const bar = `<div role="group" class="input-group  input-group-sm">
                            <div class="input-group-prepend">
                            <button disabled="disabled" id="leftbarHDLDetail_`+ revisionId + "_" + this.id + `" type="button" class="btn btn-sm btn-` + this.variant + ` btn-bar">&lt;</button>
                            </div> 
                            <input type="text" class="form-control form-control-sm" disabled="disabled" id="barHDLDetailValue_`+ revisionId + "_" + this.id + `" value="` + valueBar + `" style="text-align:center;"> 
                            <div class="input-group-append">
                            <button id="rightbarHDLDetail_`+ revisionId + "_" + this.id + `" type="button" class="btn btn-sm btn-` + this.variant + ` btn-bar">&gt;</button>
                            </div>
                            </div>`;

          symbolbar.innerHTML = bar;

          let leftbar = document.getElementById("leftbarHDLDetail_" + revisionId + "_" + this.id);
          leftbar.addEventListener("click", function (e) {

            vue.currentRevisionId = revisionId;

            if (vue.currentHDLPackage[revisionId] == 0) {

            } else {

              vue.currentHDLPackage[revisionId]--;
              vue.setHDLPackage(revisionId);
            }

          })

          let rightbar = document.getElementById("rightbarHDLDetail_" + revisionId + "_" + this.id);
          rightbar.addEventListener("click", function (e) {

            vue.currentRevisionId = revisionId;

            if (vue.currentHDLPackage[revisionId] == vue.packagesHDL[revisionId].length) {

            } else {

              vue.currentHDLPackage[revisionId]++;
              vue.setHDLPackage(revisionId);
            }
          })




        } else {
          this.symbolSvg = {};
        }

        let symbol_select = document.getElementById("symbolHDLDetail_select_" + revisionId + "_" + vue.id);
        symbol_select.addEventListener("change", function (e) {

          let id = "symbolHDLDetail__" + revisionId;

          let type = this.dataset.type

          const symbolObj = {
            name: this.value,
            partRevisionId: revisionId,
            //libraryType: LibraryTypes.PART,
            type: type
          }

          vue.currentSymbolObject = Object.assign({}, vue.currentSymbolObject, symbolObj);

          let place = document.getElementById("symbolHDLDetail__" + revisionId);
          if (place != null) {
            place.setAttribute("data-name", this.value);
          }


          const obj = {
            type: LibraryTypes.HDLSYMBOL,
            name: this.value,
            id: id
          }


          vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
            .then((result) => {

              if (result != null) {

                let id = result.id;

                vue.loadSVG(result, id, revisionId);


              }

            })


        })
      },
      async loadSVG(blob, id, revisionId){

        let svgData = await new Response(blob).text();
        
        let place = document.getElementById(id);
      
        if (place != null){
          
          place.innerHTML = "";

          var parser = new DOMParser();
          var doc = parser.parseFromString(svgData, "image/svg+xml");
          doc.documentElement.setAttribute("width", 200);
          doc.documentElement.setAttribute("height", 200);
                        
                      
          place.appendChild(doc.documentElement);

          if (place.dataset.type == PartPropertiesType.PART || place.dataset.type == PartPropertiesType.SYMBOL) {
            
            this.buildSymbolViewer(doc, place, revisionId);
          }
          if (place.dataset.type == LibraryTypes.HDLSYMBOL) {

            this.buildHDLSymbolViewer(doc, place, revisionId);
          }

          
        }
        
            
        
      },
      async loadLibraryProps(data, type, _partRevisionId) {

        let vue = this;
        const obj = {
          revisionId: data.revisionId
        }

        const partRevisionId = _partRevisionId;

        this.$store.dispatch("lm_getLibrary", obj)
          .then((result) => {


            console.log(result)

            let libraryType = "";

            for (let i = 0, lei = result.data.length; i < lei; i++) {
              if (result.data[i].type == LibraryPropertiesType.LIBRARYTYPE) {
                libraryType = result.data[i].value.display;
              }
            }

            if (type == PartPropertiesType.SYMBOL) {
              let img = document.getElementById("symbolDetail__" + _partRevisionId);
              if (img != null) {
                img.dataset.type = libraryType;
              }
              
            }
            
            if (result.status == "OK") {
              if (type == PartPropertiesType.FOOTPRINT) {
                vue.buildLibraryFootprintTable(result.data, data);
              }
              if (type == PartPropertiesType.SYMBOL || type == PartPropertiesType.HDLSYMBOL) {
                vue.buildLibrarySymbolTable(result.data, data);
              }


            }
          })
      },
      cleanLibraryProps(idL) {

        let place = document.getElementById(idL);
        if (place != null) {
          place.innerHTML = "";
        }
        
      },
      buildLibraryFootprintTable(libraryData, status) {

        let place = document.getElementById(status.idL);
        if (place == null) {
          return;
        }
        place.innerHTML = "";

        let str = "<table class=\"library-table\">";

        for (let i = 0, lei = libraryData.length; i < lei; i++) {
          let prop = libraryData[i];
          if (prop.type != "library number" && prop.type != "library type" && prop.type != "image") {
            if (prop.name != null) {
              str += "<tr class=\"prop-tr\">";
              let value = "";
              if (prop.value != null) {
                value = prop.value.display;
              } else {
                value = "";
              }
              str += "<td>" + prop.name + "</td><td>" + value + "</td>";

              str += "</tr>";
            }
          }
        }

        str += "</table>";

        place.innerHTML = str;

      },
      buildLibrarySymbolTable(libraryData, status, libraryType) {

        

              let place = document.getElementById(status.idL);
              if (place == null) {
                return
              }
              place.innerHTML = "";

              let str = "<table class=\"library-table\">";

              for (let i = 0, lei = libraryData.length; i < lei; i++) {
                let prop = libraryData[i];
                if (prop.type != "library number" && prop.type != "library type" && prop.type != "image") {
                  if (prop.name != null) {
                    str += "<tr class=\"prop-tr\">";
                    let value = "";
                    if (prop.value != null) {
                      value = prop.value.display;
                    } else {
                      value = "";
                    }
                    str += "<td>" + prop.name + "</td><td>" + value + "</td>";

                    str += "</tr>";
                  }
                }
              }

              str += "</table>";

              place.innerHTML = str;

                        

            },
            loadDataForRevisions(){


              this.properties = []
              this.propertiesRevNumbers = []

              let vue = this;
              for (let i = 0, lei = this.selectedRevisionRow.length; i < lei; i++){


                let obj = {
                  revisionId: this.selectedRevisionRow[i].revisionId,
                  revision: this.selectedRevisionRow[i].revision
                }

                this.$store.dispatch(this.$store.getters.sectionPrefix + "_getPart", obj)
                .then(function(result) {
                  console.log(result)
                  

                  result.data.sort(function(a, b){return a.priority-b.priority});

                  vue.properties.push(result.data);
                  vue.propertiesRevNumbers.push(result.revision)
                  vue.pureProperties = result.data;

                })

              }

            },
            validateValues(obj) {
              
              let vue = this;

              let arr = [obj];

              this.$store.dispatch(this.$store.getters.sectionPrefix + "_updatePartValidation", arr)
                .then((result) => {

                  console.log(result);

                  if (result.status == "OK") {
                    if (result.data.valid == false) {


                      for (let i = 0, lei = result.data.violatedRules.length; i < lei; i++) {

                        vue.displayValidationRules(result.data.violatedRules[i])
                      }
                    } else {
                      vue.resetValidationRules(obj);
                    }
                  }



                })


            },
            displayValidationRules(obj) {

              let id = "value__" + obj.propertyId;
              let elem = document.getElementById(id);
              elem.classList.add("warning");

              let idInvalidFeedback = id + "__invalid";
              let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
              elemInvalidFeedback.setAttribute("style", "display: block");
              elemInvalidFeedback.innerHTML = obj.message;

            },
            resetValidationRules(obj) {

              let id = "value__" + obj.propertyId;
              let elem = document.getElementById(id);
              elem.classList.remove("warning");

              let idInvalidFeedback = id + "__invalid";
              let elemInvalidFeedback = document.getElementById(idInvalidFeedback);
              elemInvalidFeedback.setAttribute("style", "display: none");
              elemInvalidFeedback.innerHTML = "";
      },
      checkFormValidationAfterLoad() {


        let editParts = document.getElementsByClassName('edit-part');

        for (var i = 0; i < editParts.length; i++) {

          let temp = editParts[i].id.split("__")

          const validObj = {
            propertyId: temp[1],
            value: editParts[i].value,
          }
          this.validateValues(validObj);


        }

      },
      pinsToggle() {

        
        let checkboxPinOptions = document.getElementsByClassName('checkboxPinOptionDetails');

        
        for (var i = 0; i < checkboxPinOptions.length; i++) {
          checkboxPinOptions[i].addEventListener('click', function () {
            
            let svg = document.getElementById("symbolDetail__" + this.dataset.revisionid);
            
            const pinsNameslayers = svg.querySelectorAll('[class="PINS_NAMES"]')

            const pinsNumberlayers = svg.querySelectorAll('[class="PINS_NUMBERS"]')

            if (this.checked == true) {
              for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
                pinsNumberlayers[i].style.display = "none";
              }
              for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
                pinsNameslayers[i].style.display = "block";
              }


            } else {
              for (let i = 0, lei = pinsNumberlayers.length; i < lei; i++) {
                pinsNumberlayers[i].style.display = "block";
              }
              for (let i = 0, lei = pinsNameslayers.length; i < lei; i++) {
                pinsNameslayers[i].style.display = "none";
              }


            }


          })
        }
      },
        buildTable(_dataTable){
          
          

          if (this.isEdit == true){

            this.$store.dispatch("resetPropertyToSaving");
            this.$store.dispatch("resetLibraryFilesToSaving");
            

            
            for (let i = 0, lei = _dataTable.length; i < lei; i++){
              
              let val = _dataTable[i].value;
              if (val == null){
                val = "";
              }

              let obj = {
                propertyId: _dataTable[i].id,
                value: val,
                type: _dataTable[i].type,
                isRequiredOnRequest: _dataTable[i].isRequiredOnRequest
              }

              this.$store.dispatch("addPropertyToSaving", obj);

            }

          }
          

          var tableplace = document.getElementById(this.id);

          while (tableplace.firstChild) {
              tableplace.removeChild(tableplace.firstChild);
          }

          var table = document.createElement("table");
          table.setAttribute("id", "t_" + this.id);
          table.setAttribute("class", "table table-striped table-bordered");
          table.setAttribute("style", "width:100%;");
          tableplace.appendChild(table)

          var tr1 = document.createElement("tr");

          var tr2 = document.createElement("tr");

          var thead = document.createElement("thead");
          thead.appendChild(tr1);
          thead.appendChild(tr2);

          table.appendChild(thead);

          let vue = this;


          let cols =  [
            { "data": "id" },
            { "data": "priority" },
            { "data": "name" },
          ]

          for (let el in _dataTable[0]){

            let pos = el.indexOf("value___");
            if (pos > -1){
              let obj = {
                "data": el
              }
              cols.push(obj);
            }

          }

          let columns = [
            {
              name: "Id",
              alignInColumn: "left",

            },
            {
              name: "Priority",
              alignInColumn: "left",

            },
            {
              name: this.lang.table_header_Name,
              alignInColumn: "left",
              
            },



          ]

          for (let i = 0, lei = this.selectedRevisionRow.length; i < lei; i++){
            let obj = {
              name: this.lang.table_header_Value,
              alignInColumn: "left",
              
            }
            columns.push(obj)
          }


          var columnDefs = [];
          let trigSymbol = false;
          let trigHDLSymbol = false;
          let trigFootprint = false;
          for (var i = 0, len = columns.length; i < len; i++){

            let classname = '_dt-body-'+ columns[i].alignInColumn;

            let  el = {
              targets: i,
              width: "30%",
                className: classname,
                render: function ( data, type, row, meta ) {
                  if (data == null) {
                    data = "";
                  }

                  data = $.fn.dataTable.render.text().display(data);
                  if (data.display != undefined) {
                    data.display = $.fn.dataTable.render.text().display(data.display);
                  }

                  if (meta.col == 1){
                    return data;
                  }
                  if (meta.col == 2) {


                    let strName = "<span class=\"name-column\">" + data + "</span>";
                    let required = "";
                    if (vue.isEdit == true && vue.selectedLastRevisionRow == true) {
                      let designation = "";
                      if (row.cisDesignation != "NotExposed") {
                        designation += "<b-badge v-b-popover.hover.bottom=\"'I am popover directive content!'\" title=\"" + row.cisDesignation + "\" class=\"badge badge-gray\">CIS</b-badge>";
                      }

                      if (row.hdlDesignation != "Ignored") {
                        designation += "<b-badge v-b-popover.hover.bottom=\"'I am popover directive content!'\" title=\"" + row.hdlDesignation + "\" class=\"badge badge-gray\">HDL</b-badge>";
                      }

                      
                      if (row.isRequiredOnRequest == true){
                        required += "<b-badge class=\"badge badge-blue\">Request</b-badge>";
                      }
                      if (row.isRequiredOnRelease == true){
                        required += "<b-badge class=\"badge badge-yellow\">Release</b-badge>";
                      }
                      if (row.isRevisionChanging == true){
                        required += "<b-badge class=\"badge badge-danger\">Revision</b-badge>";
                      }
                      
                      let str = "<table class=\"table-name\"><tr>";
                      str += "<td class=\"td-name\">";
                      str += strName;
                      str += "</td>";
                      str += "<td class=\"td-designation\">";
                      str += designation;
                      str += "</td>";
                      str += "<td class=\"td-required\">";
                      str += required;
                      str += "</td>";
                      str += "</tr></table>";
                      return str;
                    }

                    return strName;
                    
                  }
                  if (meta.col > 2){


                    if (meta.col > 3){
                      
                      let colorClass = "", colorClassImg = "";
                      let str = "";
                      if (row.isTheSameLikeLastRev == true){
                        colorClass = "green";
                        colorClassImg = "green-img";
                      }else{
                        colorClass = "red";
                        colorClassImg = "red-img";
                      }
                      
                      if (row.type == PartPropertiesType.IMAGE){
                        //if (data.display == ""){
                          data.display = "/static/All components/Capacitor/img.png";
                        //}

                        return "<img src=\"" + data.display + "\" class=\"img-thumbnail img-fluid " + colorClassImg + "\">";

                      }else{
                        let image = "";
                        
                        if (row.type == PartPropertiesType.SYMBOL){
                    
                          if (true) {
                            let rev = meta.col - 3
                            let symbols = data.display.split(",");
                            let idL = "detailslibsymbolprop__" + vue.selectedRevisionRow[rev].revisionId;
                            let select = "<select data-type=\"" + row.type + "\" class=\"form-control input-props symbol_select\" id=\"symbolDetail_select_" + vue.selectedRevisionRow[rev].revisionId + "_" + vue.id + "\">";
                            for (let j = 0, lej = symbols.length; j < lej; j++) {
                              let selected = "";
                              if (j == 0) {
                                selected = "selected=\"selected\"";

                              }

                              select += "<option value=\"" + symbols[j].trim() + "\" " + selected + ">" + symbols[j].trim() + "</option>";
                            }
                            select += "</select>";




                            let id = "symbolDetail__" + vue.selectedRevisionRow[rev].revisionId;
                            let barid = "bar_symbolDetail__" + vue.selectedRevisionRow[rev].revisionId + "_" + vue.id;
                            trigSymbol = true;
                            let pinOption = "<input data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" class=\"checkboxPinOptionDetails\" type=\"checkbox\" value=\"\"> " + vue.lang.label_pinSwitch + "<br>";
                            let image = select + "<br><div id=\"" + id + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + symbols[0] + "\" data-type=\"symbol\" class=\"image-zoom image-symbol\"></div>"+ pinOption +"<div id=\"" + barid + "\" class=\"bar-symbol\"></div><div id=\"" + idL + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display +"\" data-type=\"symbol\" class=\"\"></div>";

                            let revisionId = vue.selectedRevisionRow[rev].revisionId;
                            const obj = {
                              type: LibraryTypes.PART,
                              name: symbols[0],
                              id: id
                            }
                            
                            if (symbols[0] != ""){
                              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                              .then((result) => {
                                
                                if (result != null){
                                  
                                  let id = result.id;
                                                            
                                  vue.loadSVG(result, id, revisionId);
                                  
                                  
                                }
                              
                              })
                              
                              const objL = {
                                type: LibraryTypes.PART,
                                name: vue.currentSymbolObject.name,
                                idL: idL
                              }
                              
                              vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                                .then((result) => {
                                  console.log(result)
                                  if (result.data != null) {



                                    vue.loadLibraryProps(result.data, row.type, revisionId);


                                  } else {
                                    vue.cleanLibraryProps(idL);
                                  }

                                })
                            }else{
                              image = data.display;
                            }
                                              
                            return image;
                          }else{
                            
                          }
                          
                          
                                                  
                        }
                        if (row.type == PartPropertiesType.HDLSYMBOL) {

                          if (true) {
                            let rev = meta.col - 3
                            //let symbol = data.display;
                            let symbols = data.display.split(",");
                            let idL = "detailslibHDLsymbolprop__" + vue.selectedRevisionRow[rev].revisionId;
                            let select = "<select class=\"form-control input-props symbol_select\" id=\"symbolHDLDetail_select_" + vue.selectedRevisionRow[rev].revisionId + "_" + vue.id + "\">";
                            for (let j = 0, lej = symbols.length; j < lej; j++) {
                              let selected = "";
                              if (j == 0) {
                                selected = "selected=\"selected\"";

                              }

                              select += "<option value=\"" + symbols[j].trim() + "\" " + selected + ">" + symbols[j].trim() + "</option>";
                            }
                            select += "</select>";




                            let id = "symbolHDLDetail__" + vue.selectedRevisionRow[rev].revisionId;
                            let barid = "bar_symbolHDLDetail__" + vue.selectedRevisionRow[rev].revisionId + "_" + vue.id;
                            trigHDLSymbol = true;
                            let image = select + "<br><div id=\"" + id + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + symbols[0] + "\" data-type=\"hdl symbol\" class=\"image-zoom image-symbol\"></div><div id=\"" + barid + "\" class=\"bar-symbol\"></div><div id=\"" + idL + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display + "\" data-type=\"hdl symbol\" class=\"\"></div>";

                            let revisionId = vue.selectedRevisionRow[rev].revisionId;
                            const obj = {
                              type: LibraryTypes.HDLSYMBOL,
                              name: symbols[0],
                              id: id
                            }

                            if (symbols[0] != "") {
                              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                                .then((result) => {

                                  if (result != null) {

                                    let id = result.id;

                                    vue.loadSVG(result, id, revisionId);


                                  }

                                })

                              const objL = {
                                type: LibraryTypes.HDLSYMBOL,
                                name: vue.currentHDLSymbolObject.name,
                                idL: idL
                              }
                      
                              vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                                .then((result) => {
                                  console.log(result)
                                  if (result.data != null) {



                                    vue.loadLibraryProps(result.data, row.type, revisionId);


                                  } else {
                                    vue.cleanLibraryProps(idL);
                                  }

                                })
                            } else {
                              image = data.display;
                            }

                            return image;
                          } else {

                          }



                        }
                        if (row.type == PartPropertiesType.FOOTPRINT){
                          
                          if (true){
                            let rev = meta.col - 3;
                            let revisionId = vue.selectedRevisionRow[rev].revisionId;
                            let idL = "detailslibfootprintprop__" + revisionId;
                            let image = data.display + "<br><br><div id=\"footprintDetail__" + vue.selectedRevisionRow[rev].revisionId + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display +"\" data-type=\"footprint\" class=\"image-zoom image-footprint\"></div><div id=\"" + idL + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display +"\" data-type=\"footprint\" class=\"\"></div>";

                            
                            const obj = {
                              type: LibraryTypes.FOOTPRINT,
                              name: data.display,
                              id: "footprintDetail__"+vue.selectedRevisionRow[rev].revisionId
                            }
                            
                            if (data.display != ""){
                              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                              .then((result) => {
                                
                                if (result != null){
                                  
                                  let id = result.id;
                                                            
                                  vue.loadSVG(result, id, revisionId);
                                  
                                  
                                }
                              
                              })

                              const objL = {
                                type: LibraryTypes.FOOTPRINT,
                                name: data.display,
                                idL: idL
                              }

                              vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                                .then((result) => {
                                  console.log(result)
                                  if (result.data != null) {

                                    vue.loadLibraryProps(result.data, row.type, revisionId);

                                  } else {
                                    vue.cleanLibraryProps(idL);
                                  }

                                })
                            }else{
                              image = data.display;
                            }
                                                    
                            return image;
                          }
                          
                        }
                      
                      
                        str = "<span class=\"" + colorClass + "\">" + data.display + "</span>" + image;
                      }
                      if (row.type == PartPropertiesType.LINK) {
                        
                        str = "<span class=\"" + colorClass + "\">" + data.display + "</span>"
                        return str;
                      }
                      return str;
                    }else{


                      if (vue.isEdit == true&&vue.selectedLastRevisionRow == true){
                        

                        if (row.type == PartPropertiesType.TEXT){
                          let str = "";
                          
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == PartPropertiesType.LIBRARY) {
                          let str = "<div role=\"group\" class=\"input-group\">";
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control form-control-sm edit-part\"  type=\"text\" id=\"value__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<div class=\"input-group-append\">";
                          str += "<button data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"btn btn btn-secondary btn-sm btn-" + vue.variant + " form-control-sm button_action_library\" id=\"footprintId__" + row.id + "\" >" + vue.lang.button_Library + "</button>";

                          str += "</div></div>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == PartPropertiesType.ALTSYMBOLS) {
                          let str = "<div role=\"group\" class=\"input-group\">";
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control form-control-sm edit-part\"  type=\"text\" id=\"value__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<div class=\"input-group-append\">";
                          str += "<button data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"btn btn btn-secondary btn-sm btn-" + vue.variant + " form-control-sm button_action_altsymbols\" id=\"footprintId__" + row.id + "\" >" + vue.lang.button_AltSymbols + "</button>";

                          str += "</div></div>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == PartPropertiesType.PACKTYPE) {
                          let str = "";
                          
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == PartPropertiesType.PSPICEMODEL) {
                          let str = "";

                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == PartPropertiesType.DESCRIPTION) {
                          let str = "";
                          
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>"
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == PartPropertiesType.VALUE){
                          let str = "";
                          
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>"
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == PartPropertiesType.TYPE){
                          let str = "<select data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control edit-part type-select\" id=\"value__" + row.id + "\">";

                          const tab = ["Electric", "Mechanical", "Software"];
                          for (let j = 0, lej = tab.length; j < lej; j++){

                            let selected = "";
                            if (tab[j] == data.display){
                              selected = "selected=\"selected\""
                            }
                            str += "<option value=\""+tab[j]+"\" "+selected+">"+tab[j]+"</option>";
                          }
                          
                          str += "</select>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";
                  
                          return  str; 
                        }
                        if (row.type == PartPropertiesType.PARTNUMBER) {
                          let str = "";
                          str += "<input disabled=\"disabled\" data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";
                          return str;
                        }
                        if (row.type == PartPropertiesType.ROHS){
                          let str = "";
                          
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>"
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == PartPropertiesType.FOOTPRINT){
                          let str = "<div role=\"group\" class=\"input-group\">";
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control form-control-sm edit-part\"  type=\"text\" id=\"value__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<div class=\"input-group-append\">";
                          str += "<button data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"btn btn btn-secondary btn-sm btn-" + vue.variant + " form-control-sm button_action_footprint\" id=\"footprintId__" + row.id + "\" >" + vue.lang.button_Footprint + "</button>";
                                                    
                          str += "</div></div>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == PartPropertiesType.PART || row.type == PartPropertiesType.SYMBOL){
                          let str = "<div role=\"group\" class=\"input-group\">";
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control form-control-sm edit-part\"  type=\"text\" id=\"value__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<div class=\"input-group-append\">";
                          str += "<button data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"btn btn btn-secondary btn-sm btn-"+ vue.variant+" form-control-sm button_action_symbol\" id=\"symbolId__" + row.id +"\" >"+vue.lang.button_Symbol+"</button>";

                          str += "</div></div>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                        if (row.type == LibraryTypes.HDLSYMBOL) {
                          let str = "<div role=\"group\" class=\"input-group\">";
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" data-type=\"" + row.type + "\" class=\"form-control form-control-sm edit-part\"  type=\"text\" id=\"value__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<div class=\"input-group-append\">";
                          str += "<button data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\"  class=\"btn btn btn-secondary btn-sm btn-" + vue.variant + " form-control-sm button_action_symbol\" id=\"symbolId__" + row.id + "\" >" + vue.lang.button_Symbol + "</button>";

                          str += "</div></div>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;
                        }
                      
                        if (row.type == PartPropertiesType.IMAGE){
                          //if (data.display == ""){
                            data.display = "/static/All components/Capacitor/img.png";
                          //}
                          let img = "<img src=\"" + data.display + "\" class=\"img-thumbnail img-fluid\"><br><br>";
                          img += "<div class=\"custom-file b-form-file import-file b-custom-control-sm\">";
                          img += "<input data-type=\"" + row.type + "\" id=\"file_"+row.id+"\" class=\"custom-file-input is-invalid\" type=\"file\">";
                          img += "<label class=\"custom-file-label\" data-browse=\"Browse\">";
                          img += "<span class=\"d-block form-file-text\">Choose a image</span>";
                          img += "</label>";
                          img += "</div>";
                          return img;

                        }
                        if (row.type == PartPropertiesType.LINK){
                          let str = "";
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;

                        }
                        
                        if (row.type == PartPropertiesType.KICADSYMBOL) {
                          let str = "";
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";

                          return str;

                        }
                        if (row.type == PartPropertiesType.KICADFOOTPRINT) {
                          let str = "";
                          str += "<input data-type=\"" + row.type + "\" data-isRequiredOnRequest=\"" + row.isRequiredOnRequest + "\" class=\"form-control edit-part\" id=\"value__" + row.id + "\" list=\"datalist__" + row.id + "\" value=\"" + data.display + "\"></input>";
                          str += "<datalist id=\"datalist__" + row.id + "\" ></datalist>";
                          str += "<div class=\"invalid\" id=\"value__" + row.id + "__invalid\"></div>";
                          
                          return str;

                        }

                        return data.display;
                      }else{

                        if (row.type == PartPropertiesType.IMAGE){
                          //if (data.display == ""){
                            data.display = "/static/All components/Capacitor/img.png";
                          //}

                          return "<img src=\"" + data.display + "\" class=\"img-thumbnail img-fluid\">";

                        }
                        if (row.type == PartPropertiesType.LINK) {
                          
                          if (data.display != null) {
                            let link = data.display;
                            let pos = -1;
                            if (vue.globalSettings.displayHttpLinks == true) {
                              
                              pos = link.indexOf("http");

                              if (pos > -1) {
                                return "<a href='" + link + "' target='_blank'>Link</a>";
                              }
                            }
                            if (vue.globalSettings.displayLocalLinks == true) {
                              pos = link.indexOf("\\\\");
                              if (pos > -1) {
                                
                                link = link.split('\\').join('/');

                                link = "file:///" + link
                                return "<a href='" + link + "' target='_blank'>Local link</a>";
                              }
                              pos = link.indexOf("file://");
                              if (pos > -1) {

                                return "<a href='" + link + "' target='_blank'>Local link</a>";
                              }
                            }


                          } else {
                            return "";
                          }
                        }
                        let image = "";
                        if (row.type == PartPropertiesType.SYMBOL){
                    
                          if (trigSymbol == false){
                            let rev = meta.col - 3;
                            let symbols = data.display.split(",");
                            let revisionId = vue.selectedRevisionRow[rev].revisionId;
                            let idL = "detailslibsymbolprop__" + vue.selectedRevisionRow[rev].revisionId;
                            let select = "<select data-type=\"" + row.type +"\" class=\"form-control input-props symbol_select\" id=\"symbolDetail_select_" + vue.selectedRevisionRow[rev].revisionId + "_" + vue.id+"\">";
                            for (let j = 0, lej = symbols.length; j < lej; j++){
                              let selected = "";
                              if (j == 0){
                                selected = "selected=\"selected\"";

                                

                                vue.currentSymbolObject.name = symbols[j].trim();
                                vue.currentSymbolObject.type = row.type;
                                vue.currentSymbolObject.partRevisionId = vue.selectedRevisionRow[rev].revisionId;
                              }
                              
                              select += "<option value=\""+symbols[j].trim()+"\" " + selected + ">" + symbols[j].trim() + "</option>";
                            }
                            select += "</select>";


                            

                            let id = "symbolDetail__"+vue.selectedRevisionRow[rev].revisionId;
                            let barid = "bar_symbolDetail__"+vue.selectedRevisionRow[rev].revisionId + "_" + vue.id;
                            trigSymbol = true;
                            let pinOption = "<input data-revisionid=\""+ vue.selectedRevisionRow[rev].revisionId +"\" class=\"checkboxPinOptionDetails\" type=\"checkbox\" value=\"\"> " + vue.lang.label_pinSwitch + "<br>";
                            let image = select + "<br><div id=\"" + id + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + symbols[0] + "\" data-type=\"symbol\" class=\"image-zoom image-symbol\"></div>" + pinOption + "<div id=\"" + barid + "\"  class=\"bar-symbol\"></div><div id=\"" + idL + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display +"\" data-type=\"symbol\" class=\"\"></div>";

                            
                          
                            const obj = {
                              type: LibraryTypes.PART,
                              name: symbols[0],
                              id: id
                            }
                            
                            if (symbols[0] != ""){
                              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                              .then((result) => {
                                
                                if (result != null){
                                  
                                  let id = result.id;
                                                            
                                  vue.loadSVG(result, id, revisionId);
                                  
                                  
                                }
                              
                              })

                              const objL = {
                                type: LibraryTypes.PART,
                                name: vue.currentSymbolObject.name,
                                idL: idL
                              }
                              
                              vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                                .then((result) => {
                                  console.log(result)
                                  if (result.data != null) {



                                    vue.loadLibraryProps(result.data, row.type, revisionId);


                                  } else {
                                    vue.cleanLibraryProps(idL);
                                  }

                                })
                            }else{
                              image = data.display;
                            }
                                              
                            return image;
                          }else{
                            
                          }
                          
                          
                                                  
                        }
                        if (row.type == LibraryTypes.HDLSYMBOL) {

                          if (trigHDLSymbol == false) {
                            let rev = meta.col - 3;
                            //let symbol = data.display;
                            let symbols = data.display.split(",");
                            let idL = "detailslibHDLsymbolprop__" + vue.selectedRevisionRow[rev].revisionId;
                            let select = "<select class=\"form-control input-props hdlsymbol_select\" id=\"symbolHDLDetail_select_" + vue.selectedRevisionRow[rev].revisionId + "_" + vue.id + "\">";
                            for (let j = 0, lej = symbols.length; j < lej; j++) {
                              let selected = "";
                              if (j == 0) {
                                selected = "selected=\"selected\"";

                              }

                              select += "<option value=\"" + symbols[j].trim() + "\" " + selected + ">" + symbols[j].trim() + "</option>";
                            }
                            select += "</select>";
                            

                            vue.currentHDLSymbolObject.name = symbols[0];

                          

                            let id = "symbolHDLDetail__" + vue.selectedRevisionRow[rev].revisionId;
                            let barid = "bar_symbolHDLDetail__" + vue.selectedRevisionRow[rev].revisionId + "_" + vue.id;
                            trigHDLSymbol = true;
                            let image = select + "<br><div id=\"" + id + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + symbols[0] + "\" data-type=\"hdl symbol\" class=\"image-zoom image-symbol\"></div><div id=\"" + barid + "\"  class=\"bar-symbol\"></div><div id=\"" + idL + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display + "\" data-type=\"hdl symbol\" class=\"\"></div>";

                            let revisionId = vue.selectedRevisionRow[rev].revisionId;

                            const obj = {
                              type: LibraryTypes.HDLSYMBOL,
                              name: symbols[0],
                              id: id
                            }

                            if (symbols[0] != "") {
                              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                                .then((result) => {

                                  if (result != null) {

                                    let id = result.id;

                                    vue.loadSVG(result, id, revisionId);


                                  }

                                })

                              const objL = {
                                type: LibraryTypes.HDLSYMBOL,
                                name: vue.currentHDLSymbolObject.name,
                                idL: idL
                              }
                      
                              vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                                .then((result) => {
                                  console.log(result)
                                  if (result.data != null) {



                                    vue.loadLibraryProps(result.data, row.type, revisionId);


                                  } else {
                                    vue.cleanLibraryProps(idL);
                                  }

                                })
                            } else {
                              image = data.display;
                            }

                            return image;
                          } else {

                          }



                        }
                        if (row.type == PartPropertiesType.FOOTPRINT){

                          if (trigFootprint == false){
                            trigFootprint = true;
                            let rev = meta.col - 3;
                            let idL = "detailslibfootprintprop__" + revisionId;
                            let id = "footprintDetail__"+vue.selectedRevisionRow[rev].revisionId;
                            let image = data.display + "<br><br><div id=\"" + id + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display +"\" data-type=\"footprint\" class=\"image-zoom image-footprint\"></div><div id=\"" + idL + "\" data-revisionid=\"" + vue.selectedRevisionRow[rev].revisionId + "\" data-name=\"" + data.display +"\" data-type=\"footprint\" class=\"\"></div>";

                            let revisionId = vue.selectedRevisionRow[rev].revisionId;
                            
                            const obj = {
                              type: LibraryTypes.FOOTPRINT,
                              name: data.display,
                              id: id
                            }
                            
                            if (data.display != ""){
                              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getSvg", obj)
                              .then((result) => {
                                
                                if (result != null){
                                  
                                  
                                  let id = result.id;                          
                                  vue.loadSVG(result, id, revisionId);
                                  
                                  
                                }
                              
                              })

                              const objL = {
                                type: LibraryTypes.FOOTPRINT,
                                name: data.display,
                                idL: idL
                              }

                              vue.$store.dispatch("lm_getIdOfActiveLibrary", objL)
                                .then((result) => {
                                  console.log(result)
                                  if (result.data != null) {

                                    vue.loadLibraryProps(result.data, row.type, revisionId);

                                  } else {
                                    vue.cleanLibraryProps(idL);
                                  }

                                })
                            }else{
                              image = data.display;
                            }
                                                    
                            return image;
                          }else{

                          }
                          
                          
                        }
                        if (row.type == PartPropertiesType.TYPE){
                          if (data.display == null){
                            data.display == "";
                          }
                          return data.display;
                        }
                        return data.display + image;
                      }

                    }


                  }

                  return data;
                }
              }

            columnDefs.push(el);

            if (i < 4){
              var th1 = document.createElement("th");
              th1.setAttribute("id", i);
            }

            if (i < 3){
              th1.setAttribute("rowspan", "2");
            }
            if (i == 3){
              let colspan = len - i;

              th1.setAttribute("colspan", colspan);
            }


            if (i > 2){
              var th2 = document.createElement("th");

            }


            if (i < 4){
              var p1 = document.createElement("p");
              var tx1 = document.createTextNode(columns[i].name)
              
              th1.appendChild(tx1);
            }


            if (i > 2){

              var p2 = document.createElement("p");
              let rev = i - 3;
              var br = document.createElement("br");
              th2.appendChild(br);
              var tx2 = document.createTextNode(this.lang.table_subheader + " " + this.selectedRevisionRow[rev].revision)
              //p2.appendChild(tx2);

            }
            tr1.appendChild(th1);

            if (i > 2){
              th2.appendChild(tx2);
              tr2.appendChild(th2);
            }

            
          }


          var json = {};
          json.paging = false;
          json.info = false;
          json.dom = 'f<t>';
          json.data= _dataTable;
          json.myColumnFormats = columns;
          json.select = false;
          json.columns = cols;
          json.columnDefs = columnDefs;
          json.order = [1, "asc"];
          json.initComplete = function () {

            vue.checkFormValidationAfterLoad();
            vue.pinsToggle();
          }

          if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
              this.mainTable.destroy();
              
          }



          this.mainTable = $('#t_'+this.id).DataTable(json);


          this.mainTable.columns.adjust().draw();

          //hide first column in table
          this.mainTable.column( 0 ).visible( false );
          this.mainTable.column( 1 ).visible( false );

          //search input change view
          var searchplace = document.getElementById("t_" + this.id + "_filter").firstChild

          while (searchplace.firstChild) {

            if (searchplace.firstChild.textContent == "Search:"){
                searchplace.removeChild(searchplace.firstChild);
                break;
            }

          }

          searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
          searchplace.firstChild.setAttribute("class", "form-control form-control-sm")

          

          let editParts = document.getElementsByClassName('edit-part');

            for (var i = 0; i < editParts.length; i++) {
              editParts[i].addEventListener('input', function (e){

                let temp = this.id.split("__");
                let propertyId = temp[1];
                let type = this.dataset.type;
                let isRequiredOnRequest = this.dataset.isRequiredOnRequest === "true";

                let obj = {
                  propertyId: propertyId,
                  value: this.value,
                  type: type,
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: this.value,
                }
                vue.validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);

                vue.checkIfSaved();
              })
          }

          for (var i = 0; i < editParts.length; i++) {
            editParts[i].addEventListener('focus', function (e) {

              let temp = this.id.split("__");

              let obj = {
                propertyId: temp[1],
                categoryId: vue.$store.getters.selectedTreeItemObject.categoryId
              }
              

              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_getAutocompleteValues", obj)
                .then((result) => {
                  console.log(result)
                  let str = "";
                  for (let i = 0, lei = result.data.length; i < lei; i++){
                    str += "<option>" + result.data[i] + "</option>";
                  }

                  let place = document.getElementById("datalist__" + temp[1])
                  if (place == null) {
                    return
                  }
                  place.innerHTML = str;

                  
                })
            })
          }

          let symbols_buttons = document.getElementsByClassName('button_action_symbol');

          for (let i = 0, lei = symbols_buttons.length; i < lei; i++) {
            symbols_buttons[i].addEventListener('click', function (e){

              let id = this.id;
              let temp = id.split("__");
              let f = document.getElementById("value__" + temp[1] )
              let type = f.dataset.type;
              
              
              let selectedSymbols = f.value;
              let propertyId = temp[1];
              let validateValues = vue.validateValues;
              let isRequiredOnRequest = f.dataset.isRequiredOnRequest === "true";

              let funcYes = function(vue){

                let temp = id.split("__");
                let type = type;

                //let f = document.getElementById("value__" + temp[1])

                let str = "";
                for(let i = 0, lei = vue.$store.getters.selectedSymbols.length; i < lei; i++){
                  str += vue.$store.getters.selectedSymbols[i].name;
                  if (i < lei - 1){
                    str += ",";
                  }

                }
                
                f.value = str;

                const obj = {
                  propertyId: propertyId,
                  value: str,
                  type: type,
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: str,
                }
                validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);
                
              }

              
              if (type == PartPropertiesType.HDLSYMBOL) {
                vue.lang.modal_Symbols.modal_Title = vue.lang.modal_Symbols.modal_TitleHDL;
              } if (type == PartPropertiesType.PART || type == PartPropertiesType.SYMBOL) {
                vue.lang.modal_Symbols.modal_Title = vue.lang.modal_Symbols.modal_TitleSymbols
              }
              

              const obj = {
                title: "Symbols",
                text: "",
                type: "symbols",
                buttons: 2,
                size: "xl",
                selected: selectedSymbols,
                lang: vue.lang.modal_Symbols,
                data: {
                  type: type,
                },
                funcNo: "",
                funcYes: funcYes,
                
              };
              vue.$store.dispatch("showModalComponent", obj);
            })
          }

          let footprints_buttons = document.getElementsByClassName('button_action_footprint');

          for (let i = 0, lei = footprints_buttons.length; i < lei; i++) {
            footprints_buttons[i].addEventListener('click', function (e){
              let id = this.id;
              let temp = id.split("__");
              let f = document.getElementById("value__" + temp[1])              
              let isRequiredOnRequest = f.dataset.isRequiredOnRequest === "true";
              let propertyId = temp[1];
              let selectedFootprint = f.value;
              let type = f.dataset.type;
              let validateValues = vue.validateValues;

              let funcYes = function(vue){

                

                
                
                f.value = vue.$store.getters.selectedFootprints[0].name;

                const obj = {
                  propertyId: propertyId,
                  value: vue.$store.getters.selectedFootprints[0].name,
                  type: type,
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: vue.$store.getters.selectedFootprints[0].name,
                }
                validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);
                
              }

              const obj = {
                title: "Footprints",
                text: "",
                type: "footprints",
                buttons: 2,
                size: "xl",
                selected: selectedFootprint,
                lang: vue.lang.modal_Footprints,
                funcNo: "",
                funcYes: funcYes,
                
              };
              vue.$store.dispatch("showModalComponent", obj);
            })
          }  

          let libraries_buttons = document.getElementsByClassName('button_action_library');

          for (let i = 0, lei = libraries_buttons.length; i < lei; i++) {
            libraries_buttons[i].addEventListener('click', function (e) {
              let id = this.id;
              let temp = id.split("__");
              let f = document.getElementById("value__" + temp[1])
              let propertyId = temp[1];
              let type = $(this).attr("data-type");
              let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest") === "true";

              let selectedFootprint = f.value;
              let validateValues = vue.validateValues;

              let funcYes = function (vue) {





                f.value = vue.$store.getters.selectedFootprints[0].name;

                const obj = {
                  propertyId: propertyId,
                  value: vue.$store.getters.selectedFootprints[0].name,
                  type: type,
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: vue.$store.getters.selectedFootprints[0].name,
                }
                validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);

              }

              const obj = {
                title: "Libraries",
                text: "",
                type: "libraries",
                buttons: 2,
                size: "xl",
                selected: selectedFootprint,
                data: {
                  propertyId: propertyId
                },
                lang: vue.lang.modal_Libraries,
                funcNo: "",
                funcYes: funcYes,

              };
              vue.$store.dispatch("showModalComponent", obj);
            })
          }

          let altsymbols_buttons = document.getElementsByClassName('button_action_altsymbols');

          for (let i = 0, lei = altsymbols_buttons.length; i < lei; i++) {
            altsymbols_buttons[i].addEventListener('click', function (e) {

              vue.$store.dispatch(vue.$store.getters.sectionPrefix + "_deleteAllSelectedAltSymbols");

              let id = this.id;
              let temp = id.split("__");

              let propertyId = temp[1];
              let type = $(this).attr("data-type");
              let isRequiredOnRequest = $(this).attr("data-isRequiredOnRequest") === "true";

              let f = document.getElementById("value__" + temp[1])
              let selectedFootprint = f.value;



              let validateValues = vue.validateValues;

              let altSymbolsParams = vue.altSymbolsParams;

              let funcYes = function (vue) {

                let type = type;

                let str = "(";
                for (let i = 0, lei = vue.$store.getters.selectedAltSymbols.length; i < lei; i++) {

                  str += altSymbolsParams[vue.$store.getters.selectedAltSymbols[i].side] + ":" + vue.$store.getters.selectedAltSymbols[i].name;
                  if (i < lei - 1) {
                    str += ";";
                  }

                }
                str += ")";

                f.value = str;

                const obj = {
                  propertyId: propertyId,
                  value: str,
                  type: "alt symbols",
                  isRequiredOnRequest: isRequiredOnRequest
                }
                const validObj = {
                  propertyId: propertyId,
                  value: str,
                }
                validateValues(validObj);

                vue.$store.dispatch("addPropertyToSaving", obj);


              }

              const obj = {
                title: "ALT_SYMBOLS",
                text: "",
                type: "altsymbols",
                selected: selectedFootprint,
                data: {
                  propertyId: propertyId
                },
                buttons: 2,
                size: "lg",
                lang: vue.lang.modal_AltSymbols,
                funcNo: "",
                funcYes: funcYes,

              };
              
              vue.$store.dispatch("showModalComponent", obj);
            })
          }

          let image_zoom = document.getElementsByClassName("image-zoom");

          if (image_zoom != null) {

            for (let i = 0, lei = image_zoom.length; i < lei; i++) {
              image_zoom[i].addEventListener("click", function (e) {
                

                let currentLib = this.dataset.name;
                
                const svgObject = {
                  type: this.dataset.type,
                  name: currentLib,
                  id: this.dataset.type + "__" + this.dataset.revisionid,
                  revisionId: this.dataset.revisionid
                }
                
                const langObj = {
                  modal_Title: currentLib,
                  label_pinSwitch: vue.lang.label_pinSwitch
                }

                const obj = {
                  title: currentLib,
                  text: "",
                  type: "zoom_svg",
                  buttons: 1,
                  buttonName: vue.lang.modal_ZoomSvg.button_Close,
                  size: "xl",
                  lang: langObj,
                  funcNo: "",
                  funcYes: "",
                  funcCustom: "",
                  svgObject: svgObject
                };
                
                vue.$store.dispatch("showModalComponent", obj);

              })

            }

          }


        },

      }

    }
</script>
<style lang="scss">
  @import "./../../scss/_custom.scss";

  .PartDetailsComponent{
    table{

      padding: 0px !important;

    }
    table th {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }

    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }

    .dataTables_filter{
      font-size: 10px;
    }
    .searcher{
      float: left;
    }
    .dataTables_filter .form-control-sm {
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .red{
      color: $orange;
      //font-weight: 700;
    }
    .blue{
      color: $blue;
      font-weight: 700;
    }
    .yellow{
      color: $yellow;
      font-weight: 700;
    }
    .red-img{
      background-color: $red;
      border: 0px;
    }
    .green{
      color: $lightgreen;
      //font-weight: 700;
    }
    .green-img{
      background-color: $green;
      border: 0px;
    }
    .svg-image{
      background-color: white;
      margin: 10px;
      border: 1px solid #cccccc;
    }

    .btn{
      height: 26px;
    }
    td{
      word-break: break-all;
    }
    .input-group{
      min-width: 200px;
      
    }
    .input-group-append{
      //margin-top: 3px;
      margin-bottom: 3px;
    }
    .img-thumbnail{
      width: 250px;
    }
    .image-symbol{
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-bottom: 3px;
      overflow: hidden;
      width: 200px;
      height: 200px;
      display: block;
      
    }
    .image-footprint{
      background-color: #ffffff;
      border: 1px solid #dee2e6;
      border-radius: 0.25rem;
      margin-bottom: 3px;
      overflow: hidden;
      width: 200px;
      height: 200px;
    }
    .image-zoom {
      cursor: zoom-in;
    }
    svg{
      display: block;
      width: 200px;
      height: 200px;
      overflow: hidden;
      
    }
    .bar-symbol{
      margin-top: 5px;
      margin-bottom: 5px;
      width: 200px;
    }
    .btn-bar{
      height: 31px;
    }
    .symbol_select{
      padding: 1px;
      margin-top: 3px;
      
    }
    .hdlsymbol_select{
      padding: 1px;
      margin-top: 3px;
      
    }
    .table-name{
      border-color: transparent !important;;
      background-color: transparent !important;;
      margin: 4px;
      width: 100%;
    }
    .table-name tr {
      border-color: transparent !important;;
      background-color: transparent !important;;
    }
    .table-name .td-name {
      width: 40%;
      border-color: transparent !important;
      background-color: transparent !important;
    }
    .table-name .td-designation {
      width: 20%;
      border-color: transparent !important;
      background-color: transparent !important;
    }
    .table-name .td-required {
      width: 40%;
      border-color: transparent !important;
      background-color: transparent !important;
    }

    .type-select{
      padding-top: 5px;
      font-size: 0.7rem;
      padding-left: 5px;
    }
    .badge{
      margin-right: 3px;
    }
            
    input::-webkit-calendar-picker-indicator {
      opacity: 0;
    }
    .library-table {
      margin-left: 3px;
      margin-right: 5px;
      margin-bottom: 5px;
      width: 99%;
    }
    .warning{
      border-color: $redfont !important;
    }
    .invalid{
      color: $redfont;
      font-size: 0.7rem;
      display: none;
    }
    .edit-part{
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .name-column{
      white-space: nowrap;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/PartDetailsComponent.vue